import { RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useDeviceMutation } from '@/hooks/useDeviceMutation';
import { SectionHeader } from './SectionHeader';
import type { DeviceStatus } from '@/lib/types';

interface Props { device: DeviceStatus; disabled: boolean }

export function RebootSection({ device, disabled }: Props) {
  const mut = useDeviceMutation<Record<string, never>>(
    device.client_id, 'reboot', { successToast: 'Reboot queued — device will restart shortly' },
  );

  return (
    <div className="space-y-5">
      <SectionHeader title="Reboot device"
        description="Sends a reboot command to the controller. The device will reconnect within ~10 seconds." />
      <div className="rounded-xl bg-amber-50 border border-amber-200 px-4 py-3 text-sm text-amber-800">
        While the device reboots, no relays can be controlled and no status updates flow.
      </div>
      <Button
        variant="outline"
        onClick={() => { if (confirm('Reboot this device?')) mut.mutate({}); }}
        loading={mut.isPending} disabled={disabled || mut.isPending}
      >
        <RotateCcw className="w-4 h-4" /> Reboot device
      </Button>
    </div>
  );
}
